<template>
  <div>
    <div class="reset-password-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 col-lg-5 p-0">
            <div class="form-wrapper left-panel position-relative">
              <div class="logo">
                <router-link
                  :to="{ name: 'anonymousRoute-home' }"
                  class="logo-image"
                >
                  <img
                    src="/img/digital-staging-logo.svg"
                    alt="Digital Staging"
                  />
                </router-link>
              </div>
              <div
                class="reset-password-banner-mobile d-xs-block d-sm-block d-md-block d-lg-none"
              >
                <img src="/img/login-banner-mobile.png" alt="Sign up Banner" />
              </div>
              <div class="reset-password-wrapper">
                <div class="text-center">
                  <img
                    class="mb-3"
                    src="/img/icons/icon-forgot-password.svg"
                    alt="Forgaot Password"
                  />
                  <h2 class="mb-3 blue-text font-weight-bold">
                    パスワードをお忘れですか？
                  </h2>
                  <p class="mb-5 grey-text">
                    ご登録いただいたメールアドレスを入力して、パスワードの再設定を行ってください。
                  </p>
                </div>
                <form v-on:submit="sendEmailPasswordResetLink">
                  <div class="mt-4">
                    <p class="m-0 font-weight-bold">メールアドレス</p>
                    <input
                      id="email"
                      class="form-control shadow-1"
                      type="email"
                      minlength="2"
                      maxlength="100"
                      v-model="email"
                      v-on:keyup="formMessage = null"
                      placeholder="メールアドレスを入力してください"
                      required
                    />
                  </div>
                  <b-alert
                    class="m-0 mt-3 light-grey-outline grey-text"
                    variant="warning"
                    show
                    v-if="formMessage !== null"
                  >
                    {{ formMessage }}
                  </b-alert>
                  <button
                    class="btn btn-ds mt-3 dark-blue white-text"
                    type="submit"
                    v-waves.light
                  >
                    パスワード再設定
                  </button>
                </form>
                <router-link
                  class="btn d-block mt-3 grey-text"
                  :to="{ name: 'anonymousRoute-login' }"
                >
                  <font-awesome-icon
                    class="mr-3"
                    :icon="{ prefix: 'fas', iconName: 'arrow-left' }"
                  />
                  <span>ログイン画面に戻る</span>
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-7 p-0 d-none d-lg-block banner-wrap">
            <img src="/img/login-banner.png" alt="Sign up Banner" />
          </div>
        </div>
      </div>
    </div>
    <main-footer></main-footer>
  </div>
</template>

<script>
// Import Services
import { globalService_EmailPasswordResetLink } from '../services/global';

// Important Custom Components
import mainFooter from '../components/customer/Main-Footer.vue';

export default {
  metaInfo() {
    return {
      title: 'Digital Staging - Forgot Password',
    };
  },

  components: {
    'main-footer': mainFooter,
  },

  data() {
    return {
      email: null,
      formMessage: null,
    };
  },

  methods: {
    sendEmailPasswordResetLink(e) {
      let _this = this;

      e.preventDefault();

      _this.formMessage = null;

      _this.$store.state.modalLoaderMessage = 'リンクを送信中';
      _this.$bvModal.show('modal-loader');

      globalService_EmailPasswordResetLink({
        email: _this.email,
      })
        .then((response) => {
          console.log(response);

          _this.email = null;

          _this.$router.push({
            name: 'anonymousRoute-reset-password-email-sent-success',
          });

          setTimeout(() => {
            _this.$bvModal.hide('modal-loader');
          }, 500);
        })
        .catch((error) => {
          console.log(error);

          setTimeout(() => {
            _this.$bvModal.hide('modal-loader');
          }, 500);

          _this.formMessage = 'メールアドレスをご確認下さい';
        });
    },
  },
};
</script>

<style scoped>
.reset-password-wrapper .form-wrapper {
  padding: 42px;
  height: 100vh;
}

@media (max-width: 991.98px) {
  .reset-password-wrapper .form-wrapper {
    height: auto;
  }
}

.reset-password-wrapper .form-wrapper .lets-start {
  background-color: #00adee;
  color: #fff;
  border-radius: 25px;
  position: absolute;
  right: -178px;
  padding: 15px 12px;
  width: 175px;
  text-align: center;
  height: 53px;
  margin: 5px 0;
}

.reset-password-wrapper .form-wrapper .reset-password-wrapper {
  padding: 40px 40px 10px 140px;
}

.reset-password-wrapper .form-wrapper .reset-password-wrapper .title-form {
  font-weight: 500;
}

.reset-password-wrapper .form-wrapper .reset-password-wrapper form .form-group {
  position: relative;
}

.reset-password-wrapper .form-wrapper .reset-password-wrapper form .btn-google {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #bfbebe;
  border-radius: 100px;
  color: #707070;
}

.reset-password-wrapper
  .form-wrapper
  .reset-password-wrapper
  form
  .option-links
  p
  a,
.reset-password-wrapper
  .form-wrapper
  .reset-password-wrapper
  form
  .option-links
  a {
  color: #034ea1;
  text-decoration: underline !important;
}

.reset-password-wrapper .form-wrapper .form-footer {
  padding: 10px 40px 10px 140px;
  position: absolute;
  margin: 1em auto;
  overflow: hidden;
  bottom: 0;
  width: 80%;
  margin: auto;
  left: 0;
  bottom: 0;
  right: 0;
}

.reset-password-wrapper .form-wrapper .form-footer ul {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-left: -1px;
  list-style: none;
  padding-left: 0;
}

.reset-password-wrapper .form-wrapper .form-footer ul li {
  flex-grow: 1;
  flex-basis: auto;
  margin: 0.25em 0;
  padding: 0 1em;
  text-align: center;
  border-left: 1px solid #ccc;
}

.reset-password-wrapper .form-wrapper .form-footer ul li:first-child {
  border-left: 0 !important;
}

.reset-password-wrapper .form-wrapper .form-footer ul li a {
  text-decoration: underline !important;
  color: #9b9b9b;
}

.reset-password-wrapper .banner-wrap {
  height: 100vh;
  overflow: hidden;
  padding: 0;
}

.reset-password-wrapper .banner-wrap img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: left center;
  object-position: left center;
}

@media (max-width: 991.98px) {
  .reset-password-wrapper .form-wrapper {
    padding: 0 !important;
  }

  .reset-password-wrapper .form-wrapper .logo {
    padding: 20px;
  }

  .reset-password-wrapper .form-wrapper .logo .logo-image img {
    width: 172px;
  }

  .reset-password-wrapper .form-wrapper .logo .lets-start {
    right: 20px !important;
    padding: 8px 10px;
    height: auto;
    margin: 0;
  }

  .reset-password-wrapper .form-wrapper .reset-password-wrapper {
    padding: 20px;
    border-top-right-radius: 25px;
    border-top-left-radius: 25px;
    position: relative;
    top: -35px;
    background: #fff;
  }

  .reset-password-wrapper .form-wrapper .form-footer {
    padding: 20px;
    position: relative !important;
    width: 100%;
  }

  .reset-password-wrapper .form-wrapper .reset-password-banner-mobile img {
    width: 100%;
    height: 251px;
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: center;
    object-position: center;
  }
}

@media (min-width: 992px) and (max-width: 1199.98px) {
  .reset-password-wrapper .form-wrapper {
    padding: 10px 10px 10px 42px !important;
  }
  .reset-password-wrapper .form-wrapper .reset-password-wrapper,
  .reset-password-wrapper .form-wrapper .form-footer {
    padding: 40px 10px 10px 0 !important;
  }
}

@media (min-width: 992px) and (max-width: 1399.98px) {
  .reset-password-wrapper .form-wrapper {
    padding: 10px 10px 10px 42px !important;
  }
  .reset-password-wrapper .form-wrapper .reset-password-wrapper,
  .reset-password-wrapper .form-wrapper .form-footer {
    padding: 40px 10px 10px 40px !important;
  }
}

.separator {
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
}

.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 0.5px solid #b8b8b8;
}

.separator:not(:empty)::before {
  margin-right: 8px;
}

.separator:not(:empty)::after {
  margin-left: 8px;
}
</style>
